var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8345 10.6344C12.6493 11.1705 11.3289 11.3327 10.0492 11.0994C8.76945 10.8661 7.59121 10.2485 6.6714 9.32866C5.7516 8.40886 5.13392 7.23062 4.90064 5.95091C4.66737 4.6712 4.82958 3.3508 5.36566 2.1656C4.42211 2.59201 3.59609 3.24096 2.95846 4.05677C2.32084 4.87258 1.89064 5.8309 1.70479 6.84951C1.51893 7.86813 1.58296 8.91662 1.89139 9.90505C2.19981 10.8935 2.74342 11.7923 3.47558 12.5245C4.20774 13.2566 5.10659 13.8003 6.09502 14.1087C7.08344 14.4171 8.13194 14.4811 9.15055 14.2953C10.1692 14.1094 11.1275 13.6792 11.9433 13.0416C12.7591 12.404 13.4081 11.578 13.8345 10.6344Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.22d1883e1bcce532677015697e4ecee9.svg";
export { ForwardRef as ReactComponent };